import { useContext, useEffect, useState } from "react";
import ImportTable from "../ImportTable/ImportTable";
import ForceImport from "./ForceImport";
import GeoFabrikReport from "./GeoFabrikReport";
import styled from "styled-components";
import { LayerContext } from "../LayerContext";

enum Tabs {
  IMPORT_TABLE = "import-table",
  FORCE_IMPORT = "force-import",
  GEOFABRIK_REPORT = "geofabrik-report",
}

const StyledLink = styled.a`
  cursor: default;
`;

const OsmRoadsLayer = () => {
  const [currentTab, setCurrentTab] = useState(Tabs.IMPORT_TABLE);

  const value = useContext(LayerContext);
  const { setImportPage } = value!;

  useEffect(() => {
    if(currentTab === Tabs.IMPORT_TABLE) {
      setImportPage(1);
    }
  }, [currentTab]);

  const renderTab = (tab: Tabs) => {
    switch (tab) {
      case Tabs.IMPORT_TABLE:
        return <ImportTable />;
      case Tabs.FORCE_IMPORT:
        return (
          <ForceImport backToImports={() => setCurrentTab(Tabs.IMPORT_TABLE)} refreshImports={()=>window.location.reload()} />
        );
      case Tabs.GEOFABRIK_REPORT:
        return <GeoFabrikReport />;
    }
  };

  return (
    <>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <StyledLink
            className={
              currentTab === Tabs.IMPORT_TABLE
                ? "nav-link active cursor-pointer"
                : "nav-link cursor-pointer"
            }
            onClick={() => setCurrentTab(Tabs.IMPORT_TABLE)}
          >
            Imports
          </StyledLink>
        </li>
        <li className="nav-item">
          <StyledLink
            className={
              currentTab === Tabs.FORCE_IMPORT
                ? "nav-link active cursor-pointer"
                : "nav-link "
            }
            onClick={() => setCurrentTab(Tabs.FORCE_IMPORT)}
          >
            Sources
          </StyledLink>
        </li>
        <li className="nav-item">
          <StyledLink
            className={
              currentTab === Tabs.GEOFABRIK_REPORT
                ? "nav-link active"
                : "nav-link "
            }
            onClick={() => setCurrentTab(Tabs.GEOFABRIK_REPORT)}
          >
            Geofabrik
          </StyledLink>
        </li>
      </ul>
      <>
        <div className="mt-2"></div>
        {renderTab(currentTab)}
      </>
    </>
  );
};

export default OsmRoadsLayer;
